/**
 * Azure AD (Entra ID) Configuration
 *
 * Using your existing Aviator Energy Azure AD tenant.
 * Investors can be added as Guest users in Azure AD.
 *
 * App Registration: Aviator Investor Portal
 * Sign-in Audience: AzureADandPersonalMicrosoftAccount
 */

// ============================================
// AZURE AD CONFIGURATION (CONFIGURED)
// ============================================
const TENANT_ID = '60895329-770e-4a73-ad30-08f842948516';  // Aviator Energy tenant
const CLIENT_ID = 'a0256ce7-1b5c-4995-91e2-fe54ec6570b1';  // Investor Portal app
// ============================================

/**
 * MSAL Configuration for Azure AD
 */
export const msalConfig = {
    auth: {
        clientId: CLIENT_ID,
        authority: `https://login.microsoftonline.com/${TENANT_ID}`,
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
};

/**
 * Scopes for login
 */
export const loginRequest = {
    scopes: ['openid', 'profile', 'email'],
};

/**
 * API configuration
 */
export const apiConfig = {
    // Azure Functions API URL
    baseUrl: import.meta.env.VITE_API_URL || '/api',
};
